import { Button } from "../../Atoms/Button";
import { InputDate } from "../../Atoms/Inputs/InputDate";
import { Pagination } from "../../Atoms/Pagination";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useListItinerants } from "./useListItinerants";
import dayjs from "dayjs";

export const ListItinerantsTemplate = () => {
  const {
    isOpen,
    setIsOpen,
    itinerantes,
    isMobile,
    pagination,
    setNumberPage,
    Controller,
    control,
    handleSubmit,
    handleReset,
    submitFilter,
    uuidAgendamento,
    navigate,
  } = useListItinerants();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Itinerantes</Title>

        <S.WrapperButtons>
          <Button
            data-variant-outline
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <img src="/assets/svgs/icon-filter-dark.svg" alt="icone filtro" />
            Filtrar
          </Button>
        </S.WrapperButtons>

        {isOpen && (
          <S.Filter onSubmit={handleSubmit(submitFilter)}>
            <div>
              <Controller
                name="dataInicio"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <InputDate
                    minDate={new Date()}
                    selected={value ? dayjs(value).toDate() : null}
                    label="Data Inicial"
                    placeholderText="__/__/__"
                    onChange={(e) =>
                      e ? onChange(dayjs(e).format("YYYY-MM-DD")) : onChange("")
                    }
                  />
                )}
              />
            </div>
            <div>
              <Controller
                name="dataFim"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <InputDate
                    placeholderText="__/__/__"
                    minDate={new Date()}
                    label="Data Final"
                    selected={value ? dayjs(value).toDate() : null}
                    onChange={(e) =>
                      e ? onChange(dayjs(e).format("YYYY-MM-DD")) : onChange("")
                    }
                  />
                )}
              />
            </div>
            <div>
              <Button type="button" data-variant-text onClick={handleReset}>
                Limpar Tudo
              </Button>
              <Button>Buscar</Button>
            </div>
          </S.Filter>
        )}

        {itinerantes?.length > 0 && (
          <S.Table>
            {itinerantes.map((i) => (
              <S.TableItem key={Math.random()}>
                <p>
                  CIDADE: <span>{i?.endereco?.cidade}</span>
                </p>

                <p>
                  DATA DE REALIZAÇÃO:{" "}
                  <span>{dayjs(i?.dataRealizacao).format("DD/MM/YYYY")}</span>
                </p>

                <p>
                  QTD. VAGAS: <span>{i?.quantidadeVagas}</span>
                </p>

                <div>
                  <S.ButtonSelect
                    onClick={() =>
                      navigate(
                        `/agendamento/${uuidAgendamento}/confirmar-horario?itineranteId=${i.uuid}&reagendamento=true`
                      )
                    }
                  >
                    Selecionar
                  </S.ButtonSelect>
                </div>
              </S.TableItem>
            ))}
          </S.Table>
        )}

        {itinerantes?.length > 0 && (
          <Pagination
            maxPageNumbersDisplayed={isMobile ? 3 : 10}
            key={`${Math.random()} - ${pagination}`}
            totalPage={pagination.totalPage}
            totalRegister={pagination.totalPage}
            actualPage={pagination.actualPage}
            setNumberPage={setNumberPage}
          />
        )}
      </S.Wrapper>
    </S.Container>
  );
};
